import { useState, useCallback   } from "react";
import { getUsers } from "../../api/userApi";

export default function useUsers() {
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [roleSummary, setRoleSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async (filters = {}) => {
    setLoading(true);
    setError(null);

    try {
      const data = await getUsers(filters);

      setUsers(data.results || []);
      setTotalCount(data.count || 0);
      setRoleSummary(data.role_summary || {});
      
      return data;
    } catch (err) {
      console.error("Failed to fetch users:", err);
      setError(err.message || "Failed to load users");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    users,
    totalCount,
    roleSummary,
    loading,
    error,
    fetchUsers,
  };
}